import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Periodicidade } from '../periodicidade';

@Component({
    selector: 'sgt-periodicidade-picker',
    templateUrl: './periodicidade-picker.component.html',
    styleUrls: ['./periodicidade-picker.component.less']
})
export class PeriodicidadePickerComponent {
    @Input() periodicidades: Periodicidade[];
    @Input() periodicidade: number;
    @Output() periodicidadeChange = new EventEmitter<number>();

    @Input() canSelect = true;
    @Input() borderTopLeftRadius: string = null;
    @Input() borderBottomLeftRadius: string = null;
    @Input() borderTopRightRadius: string = null;
    @Input() borderBottomRightRadius: string = null;

    /** Ao alterar a periodicidade */
    onChange(periodicidade: Periodicidade) {
        if (!this.canSelect) {
            return;
        }

        this.periodicidade = periodicidade.id;
        this.periodicidadeChange.emit(this.periodicidade);
    }
}
